namespace Solovis.Reports.ReportControlHelpers {

    export class SubReportParameterSyncManager {

        public reportControl: Solovis.Reports.ReportControl;
       
        constructor(
            options: {
                reportControl: Solovis.Reports.ReportControl
            }
        ) {
            var self = this;

            this.reportControl = options.reportControl;

            var report = this.reportControl.report;

            if (report.subReportParameterSyncs) {
                $(report.subReportParameterSyncs).each(function (i, syncGroup) {
                    self._setupSyncProcess(syncGroup);
                });
            }
        }


        public _setupSyncProcess(syncGroup) {
            var self = this;
            if (syncGroup.sync) {
                $(syncGroup.sync).each(function (i, syncEntry: any) {
                    var partControl = self.reportControl.getReportPartControl(syncEntry.elementName);
                    if (partControl) {
                        self._registerForPartControlParameterChange(
                            partControl,
                            function (parameterSet, paramChangeData) {
                                if (paramChangeData.name == syncEntry.parameterName) {
                                    self._applyPropertySync(syncGroup, syncEntry, parameterSet);
                                }
                            });
                    }
                });
            }
        }


        public _applyPropertySync(syncGroup, sourceSyncEntry, parameterSet) {
            var self = this;

            var paramValue = parameterSet.getParameterValue(sourceSyncEntry.parameterName);
            var paramValueJson = JSON.stringify(paramValue);

            $(syncGroup.sync).each(function (i, syncEntry: any) {
                if (syncEntry !== sourceSyncEntry) {
                    var subReportPartControl = self.reportControl.getReportPartControl(syncEntry.elementName);
                    if (subReportPartControl && subReportPartControl.subReportControl && subReportPartControl.subReportControl._parameterSet) {
                        var currentValue = subReportPartControl.subReportControl._parameterSet.getParameterValue(syncEntry.parameterName);
                        var currentValueJson = JSON.stringify(currentValue);

                        // We do a comparison on JSON parameter values to avoid infinite loop in events.
                        if (paramValueJson != currentValueJson) {
                            var newParameterValues = {};
                            newParameterValues[syncEntry.parameterName] = paramValue;

                            subReportPartControl.subReportControl.setParameterValues(newParameterValues);
                        }
                    }
                }
            });
        }

        public _registerForPartControlParameterChange(partControl, callback) {
            var self = this;
            if (partControl.subReportControl) {
                this._registerForReportControlParameterChange(partControl.subReportControl, callback);
            }

            $(partControl).bind("subReportControlChanged", function () {
                if (partControl.subReportControl) {
                    self._registerForReportControlParameterChange(partControl.subReportControl, callback);
                }
            });
        }

        public _registerForReportControlParameterChange(subReportControl, callback) {
            var registerForParameterValueChanged = function () {
                if (subReportControl._parameterSet) {
                    $(subReportControl._parameterSet).bind("parameterValueChanged", (function (e, data) {
                        callback(subReportControl._parameterSet, data);
                    }) as any);
                }
                else {
                    console.log("SubReportParameterSyncManager._registerForReportControlParameterChange error: subReportControl._parameterSet not initialized.");
                }
            };

            if (subReportControl._parameterSet) {
                registerForParameterValueChanged();
            }
            else {
                $(subReportControl).bind("initComplete", function () {
                    registerForParameterValueChanged();
                });
            }
        }
    }

}
